import React from 'react';
import {
  Row, Col, Button, Input, Icon, Collapse
  , Pagination, Spin
} from 'antd';
import {inject, observer} from 'mobx-react';
import AppDatasBody from '../util/AppDatasBody';
import Navigation from '../public/navigation';
import {toJS} from 'mobx';

import peopleImg from '../../style/img/icon_m_wev8.jpg';//暂时使用
import applyContent from '../../style/img/applyContent.png';//暂时使用
const Panel = Collapse.Panel;

@inject('rewardStore')
@observer
class App extends React.Component {
  componentDidMount() {
    const {rewardStore, location} = this.props;
    const {getRoutes, callLastestShare} = rewardStore;
    getRoutes(location.query);
    callLastestShare();
  }

  componentWillReceiveProps(nextProps) {
  }

  onSearch() {
    const {rewardStore} = this.props;
    let {callLastestShare, searchValue} = rewardStore;
    searchValue = toJS(searchValue);
    callLastestShare(searchValue);
  }

  getApp = (apps, current, pageSize) => {
    let result = [], len = 0;
    for (let i in apps) {
      len++;
      if (len <= current * pageSize)
        result.push(
          <Row className='reward-table-con2' key={i}>
            <Col span={7}>
              <div className='reward-table-con2-single'>
                <img src={applyContent} alt=''/>
                <span className='reward-table-con2-single-span'>{apps[i].appname}</span>
              </div>
            </Col>
            <Col span={13}>
              <div className='reward-table-con2-single'>
                <span>奖励金额：{apps[i].bonus}</span>
              </div>
            </Col>
            <Col span={4}>
              <div className='reward-table-con2-single'>
                <span>{apps[i].appTime}</span>
              </div>
            </Col>
          </Row>
        )
    }
    return result;
  }
  getMore = (i) => {
    const {rewardStore} = this.props;
    let {lastestShare} = rewardStore;
    lastestShare = toJS(lastestShare);
    let len = Object.keys(rewardStore.lastestShare[i].app).length;
    rewardStore.lastestShare[i].hasMore = len > (lastestShare[i].current + 1) * lastestShare[i].pageSize;
    rewardStore.lastestShare[i].current += 1;
  }
  getCollapse = () => {
    let result = [];
    const {rewardStore} = this.props;
    let {lastestShare} = rewardStore;
    lastestShare = toJS(lastestShare);
    let j = 0;
    for (let i in lastestShare) {
      if (i !== 'total') {
        j++;
        let {
          name = '', department = '', branch = '', app = [], bonus
          , count = 0, hasMore = false, lastupdate, current, pageSize
        } = lastestShare[i];
        if (j <= 10)
          result.push(
            <Collapse style={{marginTop: 5}} key={i}>
              <Panel header={
                <Row className='reward-table-con'>
                  <Col span={4}>
                    <div className='reward-table-con-single'>
                      <div className='reward-table-con-single-people'>
                        <img src={peopleImg} alt=''/>
                      </div>
                      <div className='reward-table-con-single-people'>
                        <span>{name}</span>
                      </div>
                    </div>
                  </Col>
                  <Col span={3}>
                    <div className='reward-table-con-single'>
                      <span>{department}</span>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className='reward-table-con-single'>
                      <span>{branch}</span>
                    </div>
                  </Col>
                  <Col span={5}>
                    <div className='reward-table-con-single'>
                      <span>总共分享了{count}个流程</span>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className='reward-table-con-single'>
                      <span>{bonus}</span>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className='reward-table-con-single'>
                      <span>{lastupdate}</span>
                    </div>
                  </Col>
                </Row>
              }>
                {
                  this.getApp(app, current, pageSize)
                }
                {
                  hasMore && (
                    <div className='reward-table-more'>
                      <div className='reward-table-more-sub'
                           onClick={() => {
                             this.getMore(i);
                           }}>
                        <span>查看更多</span>
                        <Icon type="double-right"/>
                      </div>
                    </div>
                  )
                }
              </Panel>
            </Collapse>
          )
      }
    }
    return result;
  }

  render() {
    const {location, rewardStore} = this.props;
    let {
      routes, routing, searchValue
      , resetSearchValue, pagination
      , loading
    } = rewardStore;
    routes = toJS(routes);
    pagination = toJS(pagination);
    let result = this.getCollapse();
    return (
      <div className='reward'>
        <AppDatasBody location={location}>
          <Navigation datas={toJS(routes)} onClick={(obj) => {
            if (obj.path !== '/')
              routing.push({
                pathname: obj.path,
                query: {
                  id: location.query.id,
                  radioType: location.query.radioType,
                  radioItem: location.query.radioItem,
                  radioSubItem: location.query.radioSubItem,
                }
              });
            else routing.push('/');
          }}
          />
          <Row className="cs-search-mylist" style={{marginBottom: 0}}>
            <Col span={6}>
              <Row>
                <Col span={5} style={{paddingTop:5}}>
                  <label>分部：</label>
                </Col>
                <Col span={19}>
                  <Input style={{width: '90%'}} placeholder='请输入分部名称'
                         value={searchValue.branch}
                         onChange={(e) => {
                           rewardStore.searchValue.branch = e.target.value;
                         }}/>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <Row>
                <Col span={5} style={{paddingTop:5}}>
                  <label>部门：</label>
                </Col>
                <Col span={19}>
                  <Input style={{width: '90%'}} placeholder='请输入部门名称'
                         value={searchValue.department}
                         onChange={(e) => {
                           rewardStore.searchValue.department = e.target.value;
                         }}/>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <Row>
                <Col span={5} style={{paddingTop:5}}>
                  <label>姓名：</label>
                </Col>
                <Col span={19}>
                  <Input style={{width: '90%'}} placeholder='请输入姓名'
                         value={searchValue.name}
                         onChange={(e) => {
                           rewardStore.searchValue.name = e.target.value;
                         }}/>
                </Col>
              </Row>
            </Col>
            <Col span={6} style={{textAlign: 'right', paddingRight: 23}}>
              <Button type="primary"
                      style={{marginRight: 10}}
                      onClick={this.onSearch.bind(this)}>搜索</Button>
              <Button type="ghost" onClick={() => {
                resetSearchValue();
                this.onSearch();
              }}>重置</Button>
            </Col>
          </Row>
          <div className='reward-table'>
            <Row className='reward-table-title'>
              <Col span={4}><span className='reward-table-title-single'>人员</span></Col>
              <Col span={3}><span className='reward-table-title-single'>部门</span></Col>
              <Col span={4}><span className='reward-table-title-single'>分部</span></Col>
              <Col span={5}><span className='reward-table-title-single'>分享数量</span></Col>
              <Col span={4}><span className='reward-table-title-single'>奖励总数</span></Col>
              <Col span={4}><span className='reward-table-title-single'>时间</span></Col>
            </Row>
            <Spin spinning={loading}>
              <div style={{minHeight: 300}}>
                {result}
                {
                  !loading && result.length === 0 && (
                    <div className='reward-no-data'>
                      <div className='icon-Cloud-No-data'/>
                      <div>暂无数据</div>
                    </div>
                  )
                }
              </div>
              {
                result.length !== 0 && (
                  <div style={{textAlign: 'right', padding: '18px 0'}}>
                    <Pagination {...pagination}
                                onShowSizeChange={(current, size) => {
                                  rewardStore.pagination.current = current;
                                  rewardStore.pagination.pageSize = size;
                                  rewardStore.callLastestShare();
                                }}
                                onChange={(current, size) => {
                                  rewardStore.pagination.current = current;
                                  rewardStore.pagination.pageSize = size;
                                  rewardStore.callLastestShare();
                                }}/>
                  </div>
                )
              }
            </Spin>
          </div>
        </AppDatasBody>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/reward/Reward.js